import React from 'react';
import './BrandName.css';

/**
 * Nazwa aplikacji „MASZYNOWNIK" z graficznie zaakcentowanymi literami A oraz I
 * (ukłon w stronę „AI"). Litery zapisane małą literą — kontenery (logo/tytuł)
 * i tak stosują text-transform: uppercase, więc casing dziedziczy się z kontekstu.
 */
const BrandName: React.FC<{ className?: string }> = ({ className }) => (
  <span className={className ? `brand-name ${className}` : 'brand-name'}>
    M<span className="brand-ai">a</span>szynown<span className="brand-ai">i</span>k
  </span>
);

export default BrandName;
